import React from 'react';
import ReactPasswordChecklist from 'react-password-checklist';
import ValidIcon from '../../assets/images/ValidIcon.svg';
import InvalidIcon from '../../assets/images/InvalidIcon.svg';
import {
    PASSWORD_CHECKLIST_RULES,
    PASSWORD_MAX_LENGTH,
    PASSWORD_MIN_LENGTH,
} from '../../validation/password.schema';

export interface PasswordFields {
    newPassword: string;
    repeatNewPassword: string;
}

export interface PasswordInstructionsProps {
    resetPasswordDetails: PasswordFields;
    onValidation?: (isValid: boolean) => void;
}

const PasswordInstructions: React.FC<PasswordInstructionsProps> = ({
    resetPasswordDetails,
    onValidation,
}) => {
    return (
        <div>
            <p className="tooltip-heading">Password Requirements:</p>
            <ReactPasswordChecklist
                style={{
                    fontFamily: "'Source Sans Pro'",
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                }}
                className="password-checklist"
                rules={PASSWORD_CHECKLIST_RULES}
                minLength={PASSWORD_MIN_LENGTH}
                maxLength={PASSWORD_MAX_LENGTH}
                value={resetPasswordDetails.newPassword}
                valueAgain={resetPasswordDetails.repeatNewPassword}
                messages={{
                    minLength: 'At least 10 characters',
                    maxLength: 'Less than 30 characters',
                    capital: '1 uppercase letter (A-Z)',
                    number: '1 number (0-9)',
                    match: 'Both passwords match',
                }}
                validTextColor="#000"
                invalidTextColor="#000"
                iconComponents={{
                    InvalidIcon: <img src={InvalidIcon} alt="invalid" />,
                    ValidIcon: <img src={ValidIcon} alt="valid" />,
                }}
                onChange={(isValid) => {
                    if (onValidation) {
                        onValidation(isValid);
                    }
                }}
            />
        </div>
    );
};

export default PasswordInstructions;
